import React from "react";
import { defineMessages, useIntl } from "react-intl";

import "./PlayerSpecimenBanner.scss";
import InformationBanner from "../../../design-system-components/InformationBanner/InformationBanner";

const PlayerSpecimenBanner = () => {
    const intl = useIntl();
    return (
        <InformationBanner
            data={{
                content: (
                    <div className="specimen-player-banner">
                        <p>
                            {intl.formatMessage(messages.specimenPlayerBanner)}
                        </p>
                    </div>
                ),
            }}
        />
    );
};

export default PlayerSpecimenBanner;

const messages = defineMessages({
    specimenPlayerBanner: {
        id: "specimen-player-banner-text",
        defaultMessage:
            "The modules in the teacher view are not customized by AI: they are a catalog for discovering resources. To test modules with AI explore the student view.",
    },
});
